import { render } from "./CoreFunc.vue?vue&type=template&id=8e538198&scoped=true&ts=true"
import script from "./CoreFunc.vue?vue&type=script&lang=ts"
export * from "./CoreFunc.vue?vue&type=script&lang=ts"

import "./CoreFunc.vue?vue&type=style&index=0&id=8e538198&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e538198"]])

export default __exports__